import React, { useEffect, useRef, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "../../assets/css/customer-map.css"; // optional: put your toolbar/map-legend styles here

import iconUrl from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

/* Fix Leaflet default icon paths for bundlers */
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl,
  iconRetinaUrl: iconUrl,
  shadowUrl: iconShadow,
});

const SAMPLE_CUSTOMERS = []

/* --- Component --- */
const CustomerMap = ({ customers = SAMPLE_CUSTOMERS }) => {
  /* --- Configuration / sample data --- */
  let SHOP = {
    shop_name: "ETYEL HQ",
    latitude: "11.0384",
    longitude: "124.6193",
  };

  const base_root = window.location.host;
  if(base_root === "polarcare.polar-air.com" || base_root === "polarcare-staging.polar-air.com"){ //Isulan
      SHOP = {
        shop_name: "Polar-Air Aircon (Isulan HQ)",
        latitude: "6.63389",
        longitude: "124.59797",
      }
  }

  const mapEl = useRef(null);
  const mapRef = useRef(null);
  const layerGroupRef = useRef(null);
  const markersRef = useRef([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");
  const [counts, setCounts] = useState({ all: 0, ok: 0, alert: 0 });

  /* --- Helpers --- */
  const makeBearDataUrl = (hexColor = "#1d4ed8") => {
    const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'><defs><filter id='s' x='-20%' y='-20%' width='140%' height='140%'><feDropShadow dx='0' dy='2' stdDeviation='2' flood-opacity='0.25'/></filter></defs><g filter='url(#s)'><circle cx='20' cy='16' r='8' fill='${hexColor}'/><circle cx='44' cy='16' r='8' fill='${hexColor}'/><circle cx='32' cy='36' r='22' fill='${hexColor}'/><circle cx='26' cy='34' r='4' fill='#fff'/><circle cx='38' cy='34' r='4' fill='#fff'/><circle cx='26' cy='34' r='2' fill='#111'/><circle cx='38' cy='34' r='2' fill='#111'/><ellipse cx='32' cy='42' rx='7' ry='5' fill='#fff'/><circle cx='32' cy='42' r='2' fill='#222'/></g></svg>`;
    return "data:image/svg+xml;base64," + btoa(svg);
  };
  const BEAR_BLUE = makeBearDataUrl("#1d4ed8");
  const BEAR_YELLOW = makeBearDataUrl("#f59e0b");

  // normalize raw status and map to a simplified severity
    const normalizeStatus = (s = "") => s.toString().trim().toUpperCase();

    const unitSeverity = (status) => {
        // returns 'ok' | 'warning' | 'service' | 'out'
        const s = normalizeStatus(status);
        if (s === "OK" || s === "CLEANED") return "ok";
        if (s === "CLEAN DUE" || s === "CLEAN_DUE" || s === "CLEANEDUE") return "warning";
        if (s === "SERVICE") return "service";
        if (s === "OUT") return "out";
        return "warning";
    };

    //   const customerStatus = (product_units) =>
    //     product_units.some((u) => u.status === "DUE_CLEAN" || u.status === "ISSUE") ? "alert" : "ok";
    const customerStatus = (units = []) => {
        // Priority: out > service > warning > ok
        let hasOut = false, hasService = false, hasWarning = false;
        for (const u of units) {
            const sev = unitSeverity(u.status);
            if (sev === "out") { hasOut = true; break; }
            if (sev === "service") hasService = true;
            if (sev === "warning") hasWarning = true;
        }
        if (hasOut) return "out";
        if (hasService) return "service";
        if (hasWarning) return "alert"; // keeps compatibility with existing 'alert' logic
        return "ok";
    };

  const bearIcon = (kind) => {
    const url = kind === "alert" ? BEAR_YELLOW : BEAR_BLUE;
    return L.divIcon({
      className: "bear-icon",
      iconSize: [40, 40],
      html: `<div class="bear-icon" style="background-image:url('${url}'); width:40px; height:40px;"></div>`,
    });
  };

  const formatUnits = (product_units) => {
    return product_units
      .map((u) => {
        let label = `${u.brand} ${u.model ? u.model : ''}— ${u.status}`;//${u.model}
        if (u.last_service_date) label += ` (last cleaned: ${u.last_service_date})`;
        if (u.last_service_complaint) label += ` — ${u.last_service_complaint}`;
        return `<li>${label}</li>`;
      })
      .join("");
  };

  const makePopupHtml = (c) => {
    const status = customerStatus(c.product_units);
    //console.log('status', status)
    // let badge =
    //   status === "ok"
    //     ? `<span style="background:#e0f2fe;color:#075985;padding:2px 8px;border-radius:999px;font-size:12px;">All OK</span>`
    //     : `<span style="background:#fef3c7;color:#92400e;padding:2px 8px;border-radius:999px;font-size:12px;">Needs Attention</span>`;

    let badge = ''
    let address = c?.address

    return `
      <div style="min-width:240px;font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial;">
        <div style="display:flex;justify-content:space-between;align-items:center;gap:8px;">
          <div>
            <div style="font-weight:700;">${c.contact_name}</div>
            <!--<div style="font-size:12px;color:#555;">${c?.address ?? ""}</div>-->
          </div>
          ${badge}
        </div>
        <div style="margin-top:8px;font-size:13px;">
          Units:
          <ul style="margin:6px 0 0 18px;padding:0;">${formatUnits(c.product_units)}</ul>
        </div>
        <div style="margin-top:8px;display:flex;gap:6px;">
          <button onclick="window.__polar_focusTo(${c?.latitude},${c?.longitude})" style="border:1px solid #d0d7de;background:#fff;border-radius:8px;padding:6px 10px;cursor:pointer;">Zoom here</button>
          <button onclick="window.__polar_routeFromShop(${c?.latitude},${c?.longitude})" style="border:1px solid #d0d7de;background:#fff;border-radius:8px;padding:6px 10px;cursor:pointer;">Open route</button>
        </div>
      </div>
    `;
  };

  const updateCounts = (markers = markersRef.current) => {
    const all = markers.length;
    const ok = markers.filter((m) => m._polar?.status === "ok").length;
    const alert = all - ok;
    setCounts({ all, ok, alert });
  };

  const addMarkers = (data) => {
    const layerGroup = layerGroupRef.current;
    if (!layerGroup) return;
    layerGroup.clearLayers();
    markersRef.current = [];

    data.forEach((c) => {
      if(c.latitude && c.longitude){
        const status = customerStatus(c.product_units);
        const marker = L.marker([c?.latitude, c?.longitude], { icon: bearIcon(status), title: c.contact_name })
          .bindTooltip(c.contact_name, { direction: "top", offset: [0, -18] })
          .bindPopup(makePopupHtml(c));
        marker._polar = { status, customer: c };
        marker.addTo(layerGroup);
        markersRef.current.push(marker);
      }
    });

    updateCounts();
  };

  const applySearchFilter = () => {
    const q = (search || "").trim().toLowerCase();
    const f = filter;
    const layerGroup = layerGroupRef.current;
    if (!layerGroup) return;

    markersRef.current.forEach((m) => {
      const { customer, status } = m._polar;
      const matchesText =
        !q ||
        (customer.contact_name && customer.contact_name.toLowerCase().includes(q)) ||
        (customer.address && customer.address.toLowerCase().includes(q)) ||
        (customer.id && customer.id.toLowerCase().includes(q));
      const matchesFilter = f === "all" || f === status;
      const show = matchesText && matchesFilter;
      if (show) layerGroup.addLayer(m);
      else layerGroup.removeLayer(m);
    });

    updateCounts();
  };

  /* --- map lifecycle --- */
  useEffect(() => {
    const map = L.map(mapEl.current, { zoomControl: true }).setView([SHOP.latitude, SHOP.longitude], 14);
    mapRef.current = map;

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
      attribution: "&copy; OpenStreetMap contributors",
    }).addTo(map);

    // shop marker uses default icon (fixed by import override at top)
    // const shopMarker = L.marker([SHOP.latitude, SHOP.longitude], { title: SHOP.shop_name })
    //   .addTo(map)
    //   .bindPopup(`<b>${SHOP.shop_name}</b><br>Isulan, Sultan Kudarat`);

    const layerGroup = L.layerGroup().addTo(map);
    layerGroupRef.current = layerGroup;

    // expose small helpers for popup buttons
    window.__polar_focusTo = (latitude, longitude) => {
      map.setView([latitude, longitude], 17, { animate: true });
    };
    window.__polar_routeFromShop = (latitude, longitude) => {
      const url = `https://www.google.com/maps/dir/?api=1&origin=${SHOP.latitude},${SHOP.longitude}&destination=${latitude},${longitude}&travelmode=driving`;
      window.open(url, "_blank");
    };

    addMarkers(customers);

    return () => {
      // cleanup
      if (map) map.remove();
      delete window.__polar_focusTo;
      delete window.__polar_routeFromShop;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // run once

  /* re-apply filters whenever search or filter changes */
  useEffect(() => {
    applySearchFilter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, filter]);

  /* expose addMarkers in case parent wants to refresh with new data */
  useEffect(() => {
    // if customers prop changes externally, refresh markers
    addMarkers(customers);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customers]);

  /* --- Render --- */
  return (
    <div style={{ height: "100vh", width: "100%", position: "relative" }}>
      <div className="map-toolbar" style={{ position: "absolute", zIndex: 1001, top: 10, left: 10 }}>
        <strong>Polar-Air Map</strong>
        <span id="counts" style={{ marginLeft: 8 }}>
          <span>All: <span className="pill" style={{ marginLeft: 6 }}>{counts.all}</span></span>
          <span style={{ marginLeft: 8 }}>OK: <span className="pill" style={{ marginLeft: 6 }}>{counts.ok}</span></span>
          <span style={{ marginLeft: 8 }}>Alert: <span className="pill" style={{ marginLeft: 6 }}>{counts.alert}</span></span>
        </span>

        <input
          type="text"
          placeholder="Search customer or address…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ marginLeft: 8, padding: "8px 10px", borderRadius: 10, border: "1px solid #d0d7de", minWidth: 220 }}
        />

        <label style={{ marginLeft: 8, display: "inline-flex", alignItems: "center", gap: 6 }}>
          Show:
          <select value={filter} onChange={(e) => setFilter(e.target.value)} style={{ padding: "8px 10px", borderRadius: 10 }}>
            <option value="all">All</option>
            <option value="ok">OK only</option>
            <option value="alert">Alerts only</option>
          </select>
        </label>

        <button
          onClick={() => {
            const map = mapRef.current;
            if (map) {
              map.setView([SHOP.latitude, SHOP.longitude], 14, { animate: true });
            }
          }}
          style={{ marginLeft: 8, padding: "8px 10px", borderRadius: 10 }}
        >
          Center on Shop
        </button>
      </div>

      <div className="map-legend" style={{ position: "absolute", zIndex: 1001 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
          <div style={{ width: 22, height: 22, backgroundImage: `url(${BEAR_BLUE})`, backgroundSize: "contain" }} />
          <span>All units OK</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div style={{ width: 22, height: 22, backgroundImage: `url(${BEAR_YELLOW})`, backgroundSize: "contain" }} />
          <span>Due for cleaning / has issue</span>
        </div>
      </div>

      <div ref={mapEl} id="map" style={{ height: "100%", width: "100%" }} />
    </div>
  );
};

export default CustomerMap;